import gql from "graphql-tag";

export const COMPLETE_REPORT_MUTATION = gql`
  mutation CompleteReport($reportId: ID!, $supervisor: String!) {
    completeReport(reportId: $reportId, supervisor: $supervisor)
  }
`;
